/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParticipantRelationship } from './ParticipantRelationship';
import {
    ParticipantRelationshipFromJSON,
    ParticipantRelationshipFromJSONTyped,
    ParticipantRelationshipToJSON,
    ParticipantRelationshipToJSONTyped,
} from './ParticipantRelationship';

/**
 * 
 * @export
 * @interface UpdateParticipantRequest
 */
export interface UpdateParticipantRequest {
    /**
     * 
     */
    display_name?: string;
    /**
     * 
     */
    relationship?: ParticipantRelationship;
    /**
     * 
     */
    email?: string;
    /**
     * 
     */
    phone?: string | null;
    /**
     * 
     */
    contact_confirmed?: boolean;
}



/**
 * Check if a given object implements the UpdateParticipantRequest interface.
 */
export function instanceOfUpdateParticipantRequest(value: object): value is UpdateParticipantRequest {
    return true;
}

export function UpdateParticipantRequestFromJSON(json: any): UpdateParticipantRequest {
    return UpdateParticipantRequestFromJSONTyped(json, false);
}

export function UpdateParticipantRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateParticipantRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'display_name': json['display_name'] == null ? undefined : json['display_name'],
        'relationship': json['relationship'] == null ? undefined : ParticipantRelationshipFromJSON(json['relationship']),
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] === undefined ? undefined : json['phone'] === null ? null : json['phone'],
        'contact_confirmed': json['contact_confirmed'] == null ? undefined : json['contact_confirmed'],
    };
}

export function UpdateParticipantRequestToJSON(json: any): UpdateParticipantRequest {
    return UpdateParticipantRequestToJSONTyped(json, false);
}

export function UpdateParticipantRequestToJSONTyped(value?: UpdateParticipantRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'display_name': value['display_name'],
        'relationship': ParticipantRelationshipToJSON(value['relationship']),
        'email': value['email'],
        'phone': value['phone'],
        'contact_confirmed': value['contact_confirmed'],
    };
}

